<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'Home'}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('contactUs')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="contact-main" :style="backGroundColor">
        <div class="contact-info">
          <div class="contact-center">
            <div class="contact-top" v-if="common.isMobile() === false">
              {{$t('contactUs')}}
            </div>
            <form class="el-form demo-ruleForm">
              <div style="margin:20px 0px;">
                <div class="form-input first-input" >
                  <div class="el-form-item__content">
                    <div class="el-input">
                      <input type="text" autocomplete="off" class="el-input__inner" :placeholder="$t('name')" ref="username" :class="{'codeError': usernameError === true}">
                    </div>
                  </div>
                </div>
                <div class="form-input" >
                  <div class="el-form-item__content">
                    <div class="el-input">
                      <input type="text" autocomplete="off" class="el-input__inner" :placeholder="$t('email')" ref="email" :class="{'codeError': emailError === true}">
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-bottom:15px;">
                <div class="el-form-item__content" v-if="ordersOk === true">
                  <el-select v-model="value" filterable :placeholder="$t('bookingReferences')" style="width:100%"  :class="{'codeError': ordernoError === true}">
                    <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </div>
                <div class="el-form-item__content" v-else>
                  <el-select v-model="value" disabled :placeholder="$t('noOrders')" style="width:100%"  :class="{'codeError': ordernoError === true}">
                    <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </div>
              </div>
              <div style="margin-bottom:15px;">
                <div class="el-textarea">
                  <textarea rows="10" autocomplete="off" class="el-textarea__inner" style="min-height: 33px;" ref="content" :class="{'codeError': contentError === true}"></textarea>
                </div>
              </div>
            </form>
            <div class="contact-footer contact-footer-pc" :style="{ height: `${elementHeight}px`}">
              <div class="contact-footer-left">
                <div class="contact-footer-img" :style="{ height: `${elementHeight}px`}">
                  <img src="https://res.roompai.com/static/img/FullLogo_Transparent_NoBuffer.png" style="height:55px; height:55px;" :style="{ margin: `${elementMargin}`}">
                </div>
              </div>
              <div class="contact-footer-right">
                <div class="contact-footer-text">
                  <div class="contact-footer-text-center">
                    <div class="contact-footer-title contact-footer-margin-bottom">{{$t('customerService')}}:</div>
                    <div class="contact-footer-cont contact-footer-margin-bottom" v-if="contactInfo.customer_email !== ''">
                      <div v-for="(value, key) in contactInfo.customer_email" :key="key">
                        <img src="https://res.roompai.com/static/img/question/email.png" alt="" class="contact-footer-text-img">
                        <span class="contact-footer-text-span">{{ value }}</span>
                      </div>
                    </div>
                    <div class="contact-footer-cont contact-footer-margin-bottom" v-if="contactInfo.phone_internal !== ''">
                      <div v-for="(value, key) in contactInfo.phone_internal" :key="key">
                        <img src="https://res.roompai.com/static/img/question/phone.png" alt="" class="contact-footer-text-img">
                        <span class="contact-footer-text-span" style="width: 88%;">
                          {{ value }}
                          <span style="float:right">（{{$t('internationalCall')}}）</span>
                        </span>
                      </div>
                    </div>
                    <div class="contact-footer-cont contact-footer-margin-bottom" v-if="contactInfo.phone_external !== ''">
                      <div v-for="(value, key) in contactInfo.phone_external" :key="key">
                        <img src="https://res.roompai.com/static/img/question/phone.png" alt="" class="contact-footer-text-img">
                        <span class="contact-footer-text-span" style="width: 92%;">
                          {{ value }}
                          <span style="float:right">（{{$t('domesticCall')}}）</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-footer-center contact-footer-pc">
              <div class="contact-footer-center-top">
                <img src="https://res.roompai.com/static/img/question/company.png" alt="" class="contact-footer-text-img">
                <span class="contact-footer-text-span" v-if="language === 'zh'">{{contactInfo.lfname_zh}}</span>
                <span class="contact-footer-text-span" v-else>{{contactInfo.lfname_en}}</span>
              </div>
              <div class="contact-footer-center-footer" :class="{'contact-addr-en': language === 'en'}">
                <img src="https://res.roompai.com/static/img/question/addr.png" alt="" class="contact-footer-text-img">
                <span class="contact-footer-text-span" v-if="language === 'zh'">{{contactInfo.lfaddr_zh}}</span>
                <span class="contact-footer-text-span" v-else>{{contactInfo.lfaddr_en}}</span>
              </div>
            </div>

            <div class="contact-footer-mobile margin-top-20 no-border">
              {{$t('customerService')}}:
            </div>
            <div class="contact-footer-center contact-footer-mobile">
              <div class="contact-footer-center-top" v-if="contactInfo.customer_email !== ''">
                <div v-for="(value, key) in contactInfo.customer_email" :key="key">
                  <img src="https://res.roompai.com/static/img/question/email.png" alt="" class="contact-footer-text-img">
                  <span class="contact-footer-text-span">{{ value }}</span>
                </div>
              </div>
              <div v-if="contactInfo.phone_internal !== ''">
                <div class="contact-footer-center-top" style=" width: 80%; margin: 0 auto;" v-for="(value, key) in contactInfo.phone_internal" :key="key">
                  <img src="https://res.roompai.com/static/img/question/phone.png" alt="" class="contact-footer-text-img">
                  <span class="contact-footer-text-span">{{ value }}<span style="margin-left: 10px;">({{$t('internationalCall')}})</span></span>
                </div>
              </div>
              <div v-if="contactInfo.phone_external !== ''">
                <div class="contact-footer-center-top" style=" width: 80%; margin: 0 auto;" v-for="(value, key) in contactInfo.phone_external" :key="key">
                  <img src="https://res.roompai.com/static/img/question/phone.png" alt="" class="contact-footer-text-img">
                  <span class="contact-footer-text-span">{{ value }}<span style="margin-left: 10px;">({{$t('domesticCall')}})</span></span>
                </div>
              </div>
              <div class="contact-footer-center-top">
                <img src="https://res.roompai.com/static/img/question/company.png" alt="" class="contact-footer-text-img">
                <span class="contact-footer-text-span" v-if="language === 'zh'">{{contactInfo.lfname_zh}}</span>
                <span class="contact-footer-text-span" v-else>{{contactInfo.lfname_en}}</span>
              </div>
              <div class="contact-footer-center-footer" :class="{'contact-addr-en': language === 'en'}">
                <img src="https://res.roompai.com/static/img/question/addr.png" alt="" class="contact-footer-text-img">
                <span class="contact-footer-text-span" v-if="language === 'zh'">{{contactInfo.lfaddr_zh}}</span>
                <span class="contact-footer-text-span" v-else>{{contactInfo.lfaddr_en}}</span>
              </div>
            </div>
          </div>
          <!--
          <div class="contact-right">
              <img src="https://res.roompai.com/static/img/logo.png" style="width:40%; display: block; margin:35% auto 0px;filter: drop-shadow(10px 10px 10px black);">
          </div>
          -->
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { getAllOrderNos } from '@/request/order.js'
import { getCode, getContactInfo, sendContactEmail } from '@/request/question.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'contactUs',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      options: [],
      ordersOk: false,
      qrCodePresale: '',
      qrCodePostsale: '',
      value: '',
      contactUsShow: true,
      language: this.common.languageSet(this),
      backGroundColor: '',
      qrcodePositionRight: '',
      contactInfo: {},
      elementHeight: 90,
      elementMargin: '17px 0px',
      usernameError: false,
      emailError: false,
      contentError: false,
      ordernoError: false,
      customerEmail: {0: ''}
    }
  },
  created () {
    var that = this
    setInterval(function () {
      that.language = that.common.languageSet(that)
    }, 200)
  },
  mounted () {
    var buttonWidth = this.$refs.contact_send.$el.offsetWidth
    this.qrcodePositionRight = '-' + (parseInt(buttonWidth) + 20)
    var orderno = this.$route.query.orderno
    if (orderno !== '' && orderno !== undefined) {
      this.value = orderno
    }
    this.getContactInfo()
    this.getOrderNO()
    this.getCode()
  },
  watch: {
    language: function (newCur, oldCur) {
      console.log(newCur, oldCur)
    }
  },
  methods: {
    getOrderNO () {
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        // let locationHref = window.document.location.href
        // sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login'})
        this.ordersOk = false
        this.options = []
        return false
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getAllOrderNos(data).then(res => {
        if (res.flag === '200') {
          this.ordersOk = true
          this.options = res.data
        }
      })
    },
    getCode () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getCode(data).then(res => {
        if (res.flag === '200') {
          this.qrCodePresale = res.data[0]
          this.qrCodePostsale = res.data[1]
        }
      })
    },
    getContactInfo () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'time': time,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getContactInfo(data).then(res => {
        if (res.flag === '200') {
          this.contactInfo = res.data
          this.customerEmail = this.contactInfo.customer_email
          this.elementHeight = res.data.height
          var elementMargin = (this.elementHeight - 55) / 2
          this.elementMargin = elementMargin + 'px 0px'
        }
      })
    },
    sendContactEmail () {
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      var sessionid = this.common.sessionidGet(this)
      var username = this.$refs['username'].value
      var email = this.$refs['email'].value
      var content = this.$refs['content'].value
      var checkError = false
      if (username === '' || username === null) {
        this.usernameError = true
        checkError = true
      } else {
        this.usernameError = false
      }
      if (email === '' || email === null) {
        this.emailError = true
        checkError = true
      } else {
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,})$/
        if (!pattern.test(email)) {
          this.emailError = true
          checkError = true
        } else {
          this.emailError = false
        }
      }
      if (content === '' || content === null) {
        this.contentError = true
        checkError = true
      } else {
        this.contentError = false
      }
      if (checkError === true) {
        return false
      }
      if (token === null || token === 'null') {
        token = ''
      }
      var dataJson = {
        'username': username,
        'email': email,
        'orderno': this.value,
        'content': content,
        'customeremail': this.customerEmail[0],
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      sendContactEmail(data).then(res => {
        if (res.flag === '200') {
          if (this.language === 'zh') {
            this.$message({
              message: '邮件发送成功，我们将尽快回复您',
              type: 'success'
            })
          } else {
            this.$message({
              message: 'The email was sent successfully. We will reply you as soon as possible.',
              type: 'success'
            })
          }
        } else {
          if (this.language === 'zh') {
            this.$message({
              message: '邮件发送失败，您可以尝试联系下方联系电话',
              type: 'success'
            })
          } else {
            this.$message({
              message: 'The email failed to be sent, you can try to contact the phone number below.',
              type: 'success'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.contact-main{background-color: rgb(255, 241, 180);width:100%; margin:0 auto;height: 100vh;padding: 50px 0px;}
.contact-info{width:70%;height:auto; margin:0 auto;}
/*中间*/
.contact-center{width: 555px;margin: 0 auto;}
.contact-center .contact-top{border-width: 0px;width: 100%;height: 70px;line-height:70px;background-color: rgb(79, 76, 76, 1);border: none;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);font-weight: 400;font-size: 22px;color: #FCD205;text-align: center;}
.contact-center /deep/ .el-input__inner{height:46px!important;}
.contact-center /deep/ .el-select .el-input__inner{height:46px!important;}
.contact-center /deep/ .el-textarea__inner{height:132px!important;}
.contact-center .contact_send{width: 100%;height: 50px;background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);color: #FCD205;}
.contact-center .contact_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.contact-center .contact-footer{width: 100%;height: 90px;}
.contact-center .contact-footer .contact-footer-left{width: 35%;height:100%;display:inline-block;float:left;}
.contact-center .contact-footer .contact-footer-img{width:95%;height:90px;text-align:center;border: dotted 1px black; border-radius: 8px;}
.contact-center .contact-footer .contact-footer-img img{width: 55px; height: 55px; margin: 17px auto;}
.contact-center .contact-footer .contact-footer-right{width: 65%;height:100%;display:inline-block;float:left;}
.contact-center .contact-footer .contact-footer-text{width: 99%;height: 100%;text-align: center;border: dotted 1px black;border-radius: 8px;float: right;}
.contact-center .contact-footer .contact-footer-text .contact-footer-text-center{margin: 20px;text-align: left;}
.contact-center .contact-footer .contact-footer-text .contact-footer-title{font-size: 18px;}
.contact-footer-text-center img{height:20px; width: 20px;}
.contact-center .contact-footer .contact-footer-text .contact-footer-cont{font-size: 13px;}
.contact-center .contact-footer .contact-footer-text .contact-footer-margin-bottom{margin-bottom: 7px;}
.contact-center .contact-footer .contact-footer-text .contact-footer-text-img{width:20px; height:20px;display: inline-block; vertical-align: -webkit-baseline-middle;}
.contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: inline-block; vertical-align: sub;}
.contact-center .contact-footer-center{width: 100%;height: auto;text-align: center;border: dotted 1px black;border-radius: 8px;margin-top: 10px; padding:10px 0px;}
.contact-center .contact-footer-pc .contact-footer-center-top{width: 100%;height: 50%;text-align: center;line-height:30px;font-size: 13px;}
.contact-center .contact-footer-center .contact-footer-center-footer{width: 100%;height: 50%;text-align: center;line-height:30px;font-size: 13px;}
.contact-center .contact-footer-center .contact-footer-text-img{width:20px;vertical-align: middle;display: inline;}
.contact-center .contact-footer-center .contact-footer-text-span{font-size: 13px;display: inline;vertical-align: middle;}
.contact-center .contact-footer-center .contact-addr-en{line-height:15px;}

.contact-center .contact-footer-mobile{width: 100%;text-align: center;border: dotted 1px black;border-radius: 8px;line-height:30px;margin-top: 10px;}
.contact-center .contact-footer-mobile .contact-footer-center-top{width: 100%;text-align: center;font-size: 13px;line-height:30px;}
.contact-center .contact-footer-mobile .contact-footer-center-footer{width: 100%;text-align: center;height:auto;line-height:30px;font-size: 13px;}
/*左侧 */
.contact-left{ width:50%;display:inline-block; float:left;}
.form-input{width:48.8%;display:inline-block;}
.first-input{margin-right: 1%;}
.contact-top{border-width: 0px;width: 100%;height: 95px;line-height:95px;background-color: rgb(79, 76, 76, 1);border: none;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);font-weight: 400;font-size: 22px;color: #FCD205;text-align: center;}
.contact_send{width: 100%;height: 50px;background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);color: #FCD205;}
.contact_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.el-input.is-active .el-input__inner, .el-input__inner:focus,.el-select .el-input.is-focus .el-input__inner,.el-textarea__inner:focus,.el-select .el-input__inner:focus{border-color:rgba(252,210,5,1);box-shadow:0px 0px 8px rgba(252,210,5);}
/* 右侧 */
.contact-right{ display:inline-block;width:50%; height:600px;}
.el-select-dropdown{display:block;}
.qrcode-pc{width:100px; height: 237px; background-color: #fff;position: relative; top: -55px;-webkit-box-shadow: 0 2px 12px #dcdfe2; box-shadow: 0 2px 12px #dcdfe2; font-size: 12px; padding: 10px 5px; text-align: center;}
.codeError{border: 2px solid rgba(225, 45, 45, 1);}

/* 响应式 */
  @charset "UTF-8";

  @media only screen and (max-width:260px){
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info .contact-right{display:none;}
    .contact-main .contact-info{width:98%;}
    .form-input{width:100%;}
    .first-input{margin-bottom: 20px;}
    .contact-main .contact-info .contact-left{width:100%;}
    .contact-center{width:90%;}
    .contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: unset;}

    .contact-footer-pc{display:none;}
    .contact-footer-mobile{}
  }

  @media only screen and (min-width:260px)  and (max-width:450px){
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info .contact-right{display:none;}
    .contact-main .contact-info{width:98%;}
    .form-input{width:100%;}
    .first-input{margin-bottom: 20px;}
    .contact-main .contact-info .contact-left{width:100%;}
    .contact-center{width:90%;}
    .contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: unset;}

    .contact-footer-pc{display:none;}
    .contact-footer-mobile{}
  }

  @media only screen and (min-width:450px) and (max-width:780px){
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info .contact-right{display:none;}
    .contact-main .contact-info{width:90%;}
    .contact-main .contact-info .contact-left{width:100%;}
    .contact-center{width:90%;}
    .contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: unset;}

    .contact-footer-pc{display:none;}
    .contact-footer-mobile{}
  }

  @media only screen and (min-width:780px) and (max-width:992px){
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info .contact-right{display:none;}
    .contact-main .contact-info{width:60%;}
    .contact-main .contact-info .contact-left{width:100%;}
    .contact-center{width:90%;}
    .contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: unset;}

    .contact-footer-pc{display:none;}
    .contact-footer-mobile{}
  }

  @media only screen and (min-width:992px) and (max-width:1200px){
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info .contact-right{display:none;}
    .contact-main .contact-info{width:60%;}
    .contact-main .contact-info .contact-left{width:100%;}
    .contact-center{width:90%;}
    .contact-center .contact-footer .contact-footer-text .contact-footer-text-span{display: unset;}

    .contact-footer-pc{}
    .contact-footer-mobile{display:none;}

  }

  @media only screen and (min-width:1200px) and (max-width:1400px) {
    .contact-main {padding-top:10px; padding-bottom:50px;}
    .contact-main .contact-info{width:90%;}

    .contact-footer-pc{}
    .contact-footer-mobile{display:none;}
  }

  @media only screen and (min-width:1400px) and (max-width:1920px) {

    .contact-footer-pc{}
    .contact-footer-mobile{display:none;}
  }

  @media only screen and (min-width:1920px) {

    .contact-footer-pc{}
    .contact-footer-mobile{display:none;}
  }
</style>



// WEBPACK FOOTER //
// src/components/question/contactUs.vue